import React, { useState, useRef } from 'react';

import {
  exportRunAsCsv,
  exportRunAsOverlayCsv,
  exportRunAsGpx,
  exportRunAsJson,
} from '../common/RunExporter.js';

const ExportDropdown = ({ contentRunSelected, contentData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const dropdownButtonRef = useRef(null);
  const dropdownMenuRef = useRef(null);

  const toggleDropdown = () => {
    const buttonRect = dropdownButtonRef.current.getBoundingClientRect();
    const menuHeight = dropdownMenuRef.current.scrollHeight;

    // Position the dropdown menu relative to the button
    dropdownMenuRef.current.style.top = `${buttonRect.bottom}px`;
    // dropdownMenuRef.current.style. = `${buttonRect.right}px`;
    dropdownMenuRef.current.style.left = `${buttonRect.left - 100}px`;
    dropdownMenuRef.current.style.right = `${buttonRect.right}px`;
    // dropdownMenuRef.current.style.width = `30px`;

    // Toggle visibility
    setIsVisible(!isVisible);
  };

  return (
    <div className="dropdown m-1">
      <button
        className="btn btn-outline-primary dropdown-toggle m-1"
        type="button"
        id="exportDropdown"
        ref={dropdownButtonRef}
        aria-expanded={isVisible}
        onClick={toggleDropdown}
      >
        Export
      </button>
      <ul
        className={`dropdown-menu ${isVisible ? 'show' : ''}`}
        ref={dropdownMenuRef}
        style={{
          position: 'fixed',
          display: isVisible ? 'block' : 'none',
          zIndex: 1000,
        }}
        aria-labelledby="exportDropdown"
      >
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => {
              exportRunAsGpx(contentRunSelected, contentData);
              toggleDropdown();
            }}
          >
            Export as GPX
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => {
              exportRunAsCsv(contentRunSelected, contentData);
              toggleDropdown();
            }}
          >
            Export as CSV
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => {
              exportRunAsOverlayCsv(contentRunSelected, contentData);
              toggleDropdown();
            }}
          >
            Export as Overlay CSV
          </a>
        </li>
        <li>
          <a
            className="dropdown-item"
            href="#"
            onClick={() => {
              exportRunAsJson(contentRunSelected, contentData);
              toggleDropdown();
            }}
          >
            Export as JSON
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ExportDropdown;
